import { navItems } from "@/mocks/homeData";

const CONTENT_LINKS = [
  { label: "年度大事件合集", href: "#collections" },
  { label: "直播翻车合集", href: "#collections" },
  { label: "回应与道歉合集", href: "#collections" },
  { label: "考古旧视频合集", href: "#collections" },
];

const ARCHIVE_LINKS = [
  { label: "热门排行盘点", href: "#ranking" },
  { label: "黑料网红名单", href: "#names" },
  { label: "年度汇总时间线", href: "#year" },
  { label: "吃瓜热评区", href: "#comments" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 px-4 py-14 text-background-100 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 font-heading text-lg font-bold text-primary-900">
              黑
            </span>
            <span className="font-heading text-xl font-bold text-background-50">
              黑料网红
            </span>
          </div>
          <p className="mt-5 max-w-md text-[13px] leading-relaxed text-background-200">
            黑料网红大全持续更新，把名单、排行、盘点与合集整理在一处，
            年度汇总按时间顺序还原完整的讨论脉络，满足吃瓜与追料的阅读需求。
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {["黑料网红名单", "黑料网红排行", "黑料网红盘点", "黑料网红合集"].map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center rounded-full bg-primary-800 px-3 py-1 font-label text-[11px] text-background-200"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <h3 className="font-heading text-sm font-bold text-background-50">浏览分区</h3>
          <ul className="mt-5 flex flex-col gap-3">
            {navItems.map((item) => (
              <li key={item.label}>
                <a
                  href={item.href}
                  className="font-label text-[13px] text-background-200 transition-colors hover:text-background-50"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="font-heading text-sm font-bold text-background-50">热门合集</h3>
          <ul className="mt-5 flex flex-col gap-3">
            {CONTENT_LINKS.map((item) => (
              <li key={item.label}>
                <a
                  href={item.href}
                  className="font-label text-[13px] text-background-200 transition-colors hover:text-background-50"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="font-heading text-sm font-bold text-background-50">归档入口</h3>
          <ul className="mt-5 flex flex-col gap-3">
            {ARCHIVE_LINKS.map((item) => (
              <li key={item.label}>
                <a
                  href={item.href}
                  className="font-label text-[13px] text-background-200 transition-colors hover:text-background-50"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-label text-xs text-background-300">
          © 2026 黑料网红 · 内容为话题整理，仅供浏览参考
        </p>
        <p className="font-label text-xs text-background-300">
          名单 / 排行 / 盘点 / 合集 · 每期持续更新
        </p>
      </div>
    </footer>
  );
}